import { DBSchema, openDB } from "idb";
import { Person, PrayerRequest } from "../models";

export const prayersdb = await openDB<PrayersDB>("prayers", 3, {
  upgrade: (db) => {
    const prayersTable = db.createObjectStore("prayerRequests", {
      keyPath: "id",
      autoIncrement: true,
    });
    prayersTable.createIndex("from", "from", { multiEntry: false, unique: false });
    prayersTable.createIndex("answered", "answered", { multiEntry: false, unique: false });

    const peopleTable = db.createObjectStore("people", {
      keyPath: "id",
      autoIncrement: true,
    });

    peopleTable.createIndex("name", "name", { multiEntry: false, unique: false });
  },
  blocking(currentVersion, blockedVersion, event) {
    console.error("The database is blocking another system from upgrading or pruning.");
    prayersdb.close();
    if (location && location.replace) {
      location.replace(location.href);
    } else if (self instanceof DedicatedWorkerGlobalScope) {
      self.close();
    } else {
      throw new Error("Expected to find a way to crash the system that is using the database.");
    }
  },
});

export interface PrayersDB extends DBSchema {
  prayerRequests: {
    key: number;
    value: PrayerRequest;
    indexes: {
      from: string;
      answered: -1 | 0 | 1;
    };
  };
  people: {
    key: number;
    value: Person;
    indexes: {
      name: string;
    };
  };
}
